// extracted by mini-css-extract-plugin
export default {"card":"OrderStatCard_card__HYFyB","iconWrapper":"OrderStatCard_iconWrapper__sU+ju","label":"OrderStatCard_label__7mby4","value":"OrderStatCard_value__xZBPC"};